<template>
    <div class="bg-white px-3 index">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-ac u-jsb " :inline="true">
                <div>
                    <el-form-item label="模糊搜索">
                        <el-input v-model="titles" placeholder="请输入内容" clearable size="small"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="add">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="name" label="问题" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip width="180"> </el-table-column>
                <el-table-column label="操作" width="220">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button size="mini" type="success" @click="handleComment(scope.$index, scope.row)">评论
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDelete( scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <!-- 设置 -->
        <el-dialog title="问题设置" :visible.sync="dialoged" top="80px" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="forms" :model="forms" label-width="140px" :rules="rules" class="demo-ruleForm">
                    <el-form-item label="人员" prop='zs_value'>
                        <el-select v-model="forms.zs_value" placeholder="请选择" size="small" filterable
                            @change="selectUser">
                            <el-option v-for="item in  ry_options" :key="item.id" :label="item.username+'--'+item.sex_text"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="问题" prop="problem">
                        <el-input size="small" v-model="forms.problem"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submited('forms')" size="small">确 定</el-button>
                <el-button @click="dialoged = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 编辑 -->
        <el-dialog title="编辑设置" :visible.sync="dialogs" top="80px" width="60%" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm">
                    <el-form-item label="问题:">
                        <div class="blues">{{arrxq.name}}</div>
                    </el-form-item>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="评论:">
                                <div class="lefts">
                                    <el-timeline :reverse="true">
                                        <el-timeline-item v-for="(item,index) in listItem" :key="index"
                                            :timestamp="item.create_time" placement="top">
                                            <div class="concon">
                                                <div class="u-f u-ac u-jsb">
                                                    <div class="u-f u-ac">
                                                        <img :src="item.avatar" alt="" class="imgs">
                                                        <div>{{item.create_user_text}}</div>
                                                    </div>
                                                    <div>
                                                        <i class="el-icon-delete delt"
                                                            @click="handleDelete(item,1)"></i>
                                                    </div>
                                                </div>
                                                <div class="">{{item.reply_content}}</div>
                                            </div>
                                        </el-timeline-item>
                                    </el-timeline>
                                </div>
                            </el-form-item>

                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="助手" prop="zs_value">
                                <el-select v-model="form.zs_value" placeholder="请选择" filterable size="small">
                                    <el-option v-for="item in zs_options" :key="item.id" :label="item.nickname"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="评论" prop="textareas">
                                <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.textareas">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit('form')" size="small">确 定</el-button>
                <el-button @click="dialogs = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                dialog: false,
                titles: '',
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,

                // 
                eid: '',
                dialogs: false,
                zs_options: [],
                form: {
                    zs_value: '',
                    textareas: '',
                },
                rule: {
                    textareas: [{
                        required: true,
                        message: '评论不能为空'
                    }],
                    zs_value: [{
                        required: true,
                        message: '助手不能为空'
                    }]
                },

                dialoged: false,
                forms: {
                    problem: '',
                    zs_value: '',
                },
                rules: {
                    problem: [{
                        required: true,
                        message: '问题不能为空'
                    }],
                    zs_value: [{
                        required: true,
                        message: '人员不能为空'
                    }]
                },
                listItem: [],
                arrxq: '',
                ry_options: [],
                selectUserdata: '',
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        created() {
            if (sessionStorage.getItem('xuniUsers')) {
                this.ry_options = JSON.parse(sessionStorage.getItem('xuniUsers'))
            } else {
                this.getxnUser()
            }
        },
        mounted() {
            let that = this
            that.getxx()
            that.getHeight()
            that.begin()
        },
        methods: {
            getxnUser() {
                this.axios
                    .post(
                        "/admin/h5/fictitiousUsers", {
                            page: 1,
                            page_count: 3000
                        }, {
                            token: true
                        }
                    )
                    .then((res) => {
                        this.ry_options = res.data.data.list
                        sessionStorage.setItem('xuniUsers', JSON.stringify(res.data.data.list))
                    })
                    .catch((err) => {

                    });
            },
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 200 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/dictionaryQuestion/list", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        keyword: that.titles,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.totalCount
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            // 新增
            add() {
                let that = this
                that.dialoged = true
                that.eid = '0'
                that.forms.problem = ''
                 that.forms.zs_value=''
            },
            selectUser(val) {
                this.ry_options.forEach(e => {
                    if (e.id == val) {
                        this.selectUserdata = e
                    }
                })
            },
            // 设置
            submited(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    let urls = ''
                    if (this.eid && this.eid != '0') {
                        urls = "/admin/dictionaryQuestion/update"
                    } else {
                        urls = "/admin/dictionaryQuestion/save"
                    }
                    axios
                        .post(urls, {
                            id: that.eid,
                            name: that.forms.problem,
                            create_user: that.forms.zs_value,
                            is_fictitious: 2,
                            author: that.user.id,
                            fictitious_avatar: this.selectUserdata.avatar,
                            fictitious_username: this.selectUserdata.username,
                            fictitious_phone: this.selectUserdata.phone,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.dialoged = false
                                that.search()
                                that.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                            } else {
                                that.$message.error(response.data.message);
                            }
                        })
                        .catch(error => {})
                })
            },
            handleEdit(index, row) {
                let that = this
                that.dialoged = true
                that.eid = row.id
                that.forms.problem = ''
                that.forms.zs_value = ''
                this.getinfo(1)
            },
            getinfo(val) {
                let that = this
                axios
                    .post("/admin/dictionaryQuestion/read", {
                        id: that.eid,
                        author: this.user.id,
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        if (data) {
                            if (val == '1') {
                                that.forms.problem = data.name
                                that.forms.zs_value = data.create_user
                            } else {
                                this.arrxq = data
                                that.listItem = data.question_comment
                            }
                        } else {
                            this.eid = ''
                        }
                    })
                    .catch(error => {})
            },
            // 
            handleComment(index, row) {
                let that = this
                that.dialogs = true
                that.eid = row.id
                that.form.zs_value = ''
                that.form.textareas = ''
                that.getinfo(2)
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios
                            .post("/admin/dictionaryQuestionComment/save", {
                                dictionary_question_id: that.eid,
                                create_user: this.form.zs_value,
                                reply_content: this.form.textareas,
                                author: that.user.id
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.getinfo(2)
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.message);
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },

            handleDelete(row, val) {
                let that = this
                that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var urls = val == '1' ? "/admin/dictionaryQuestionComment/del" :
                        "/admin/dictionaryQuestion/del"
                    axios
                        .post(urls, {
                            id: row.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                if (val) {
                                    return that.getinfo(2)
                                }
                                that.search()
                            } else {
                                that.$message.error(response.data.message);
                            }
                        })
                        .catch(error => {})

                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 获取助手
            getxx() {
                let that = this
                axios
                    .post("/admin/doctorAssistantList", {}, {
                        token: true
                    })
                    .then(response => {
                        that.zs_options = response.data.data
                    })
                    .catch(error => {})
            },

        },

    };
</script>


<style scoped>
    .imgs {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 5px;
    }

    .lefts {
        max-height: 500px;
        overflow: auto;
    }

    .delt {
        color: red;
        font-size: 20px;
    }

    .blues {
        color: #409eff;
    }

    .concon {
        background: #f5f5f5;
        padding: 10px;
        border-radius: 10px;
    }
</style>